<ng-template>
  <div class="container mat-elevation-z2">
    <div class="header">
      <span class="h3 title">{{ 'CLIENT.MESSENGER.TITLE' | translate }}</span>
    </div>
    <lin-chat-toolbar-list [style.width]="'390px'"></lin-chat-toolbar-list>
  </div>
</ng-template>
